

export class DiceStyle {
    static readonly DEFAULT = new DiceStyle(
        "default",
        "Default",
        "The result of the dice is revealed before the rolling of the dice is finished.",
    );

    static readonly FAST = new DiceStyle(
        "fast",
        "Fast",
        "The dice animate faster so you can get to making your move quicker.",
    );

    static readonly DRAMATIC = new DiceStyle(
        "dramatic",
        "Dramatic",
        "Wait until the dice have finished rolling to show the result.",
    );

    static values(): DiceStyle[] {
        return [
            DiceStyle.DEFAULT,
            DiceStyle.FAST,
            DiceStyle.DRAMATIC,
        ];
    }

    private readonly id: string;
    private readonly name: string;
    private readonly desc: string;

    constructor(
        id: string,
        name: string,
        desc: string,
    ) {
        this.id = id;
        this.name = name;
        this.desc = desc;
    }

    getID(): string {
        return this.id;
    }

    getName(): string {
        return this.name;
    }

    getDesc(): string {
        return this.desc;
    }

    static getByID(id: string): DiceStyle {
        for (const settings of DiceStyle.values()) {
            if (settings.id === id)
                return settings;
        }
        throw new Error(`Unknown RoyalUr dice style ${id}`);
    }

    static getByIDOrNull(id: string | null): DiceStyle | null {
        if (id === null)
            return null;

        for (const settings of DiceStyle.values()) {
            if (settings.id === id)
                return settings;
        }
        return null;
    }
}
